import React from 'react';

export async function sleep(delay: number) {
  return new Promise(resolve => {
    setTimeout(() => resolve(), delay);
  });
}

/**
 * 改行の反映とhttps文字列をaタグに入れて返す
 * @param text
 */
export const insertLine = (text: string) => {
  const regExp = /(https?:\/\/\S+|\n)/;
  const regExpBr = /\n/;
  const regExpLink = /https?:\/\/\S+/;
  return (text || '').split(regExp).map(function(line, i) {
    return line.match(regExpBr) ? (
      <br key={i} />
    ) : line.match(regExpLink) ? (
      <a target="_blank" href={line} key={i} rel="noopener noreferrer">
        {line}
      </a>
    ) : (
      line
    );
  });
};
